import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
export const tasksService = {
  all: function (reportId) {
    let queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return fetch("/api/time_tracking/claim_project_reports/".concat(reportId, "/tracking_tasks?").concat(queryParams), request.get);
  }
};